/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';

import {AngularModalService} from '../common/modal/angular-modal.service';
import {AdUnitBulkActionModalComponent} from './ad-unit-bulk-action-modal.component';

@Injectable({providedIn: 'root'})
export class AdUnitBulkActionService {
  constructor(private readonly angularModalService: AngularModalService) {
  }

  createBulkAction(list: any): () => void {
    return () => {
      this.angularModalService.show(AdUnitBulkActionModalComponent, {
        class: 'modal-lg',
        initialState: {list}
      });
    };
  }
}
